var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEyeInvisible = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m2.666 2.667 10.667 10.666m-4-3.842a2 2 0 0 1-2.824-2.824m6.563 3.738c.38-.332.721-.665 1.014-.974a2.056 2.056 0 0 0 0-2.862C12.784 5.197 10.543 3.333 8 3.333c-.595 0-1.172.102-1.725.275m-1.942.928c-.972.62-1.802 1.382-2.42 2.033a2.056 2.056 0 0 0 0 2.862C3.217 10.803 5.456 12.667 8 12.667c1.245 0 2.418-.447 3.443-1.064",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})));
export default SvgEyeInvisible;